import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable()
export class BudgetService {
  constructor(private http: Http) {}

  private baseurl = environment.apiBaseUrl;

  // save an entry into budget table for very first time when a new project is added
  saveBudget(projectId, data) {
    return this.http
      .post(`${this.baseurl}/budget/save`, { projectId, data })
      .map((res: Response) => res.json());
  }

  // update fields value onchange action to save them into db simultanously
  updateBudget(projectId, data) {
    return this.http
      .post(`${this.baseurl}/budget/update`, { projectId, data })
      .map((response: Response) => response.json());
  }

  // get saved budget data from db
  getBudget(projectId) {
    return this.http
      .post(`${this.baseurl}/budget/get`, { projectId })
      .map((res: Response) => res.json());
  }

  // getBudgetFields(projectId)
  // {
  //   return this.http.post(this.baseurl+'/budget/getBudgetFields',{projectId}).
  //     map((res:Response) => { return res.json() });
  // }
}



// WEBPACK FOOTER //
// ./src/app/service/budget.service.ts